module.exports = __webpack_public_path__ + "static/media/Jose Paix.ba8cdcdc.png";